<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CardHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hiddenLeft: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['back', 'close'],
  setup(_, { emit }) {
    return {
      handleBack() {
        emit('back')
      },
      handleClose() {
        emit('close')
      },
    }
  },
})
</script>

<template>
  <q-item dense class="q-pa-none">
    <q-item-section avatar class="q-pr-none">
      <q-btn
        v-if="!hiddenLeft"
        icon="arrow_back_ios"
        size="12px"
        flat
        color="primary"
        @click="handleBack"
      />
    </q-item-section>
    <q-item-section>
      <div v-if="title" class="text-center">
        <span class="text-black text-body1 text-uppercase text-weight-medium">
          {{ title }}
        </span>
        <span v-if="description" class="text-dark text-caption q-pl-xs">
          {{ description }}
        </span>
      </div>
      <template v-else>
        <slot name="title" />
      </template>
    </q-item-section>
    <q-item-section side style="padding-left: 0">
      <q-btn
        icon="close"
        size="12px"
        flat
        color="primary"
        @click="handleClose"
      />
    </q-item-section>
  </q-item>
</template>
